'use client';

import { c as _c } from "react/compiler-runtime";
import { pushYouTubePlayingEvent } from '@/globals/analytics/events/pushYouTubePlayingEvent';
import { addYouTubePostMessageListener, postYouTubeInitialEvents } from '@/sections/youTube/youTubeEvents';
import { posix as posixPath } from 'path';
import { useEffect, useRef } from 'react';
import { getYoutubeId } from './getYoutubeId';
import { translateInline } from '@/globals/translate/translateInline';
import { MarkupError } from '../markup/helpers/MarkupError';
export const YouTubeClient = t0 => {
  const $ = _c(16);
  const {
    src,
    origin,
    className
  } = t0;
  const iFrameRef = useRef(null);
  const unplayedRef = useRef(true);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const iFrame = iFrameRef.current;
      if (iFrame == null) {
        return;
      }
      const abortController = new AbortController();
      iFrame.addEventListener("load", () => {
        const targetWindow = iFrame.contentWindow;
        if (targetWindow == null) {
          return;
        }
        addYouTubePostMessageListener(targetWindow, "playing", () => {
          if (unplayedRef.current) {
            unplayedRef.current = false;
            pushYouTubePlayingEvent();
          }
        }, {
          signal: abortController.signal,
          once: true
        });
        postYouTubeInitialEvents(targetWindow);
      }, {
        signal: abortController.signal,
        once: true
      });
      return () => {
        abortController.abort();
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (src == null) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <MarkupError>{"Missing YouTube URL"}</MarkupError>;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let iframeURL;
  let t3;
  if ($[3] !== origin || $[4] !== src) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const youtubeId = getYoutubeId(src);
      if (youtubeId == null) {
        if (src.includes("/shorts/")) {
          const t4 = `YouTube Shorts are not supported: ${src}`;
          let t5;
          if ($[7] !== t4) {
            t5 = <MarkupError>{t4}</MarkupError>;
            $[7] = t4;
            $[8] = t5;
          } else {
            t5 = $[8];
          }
          t3 = t5;
          break bb0;
        }
        const t4 = `Unsupported YouTube URL: ${src}`;
        let t5;
        if ($[9] !== t4) {
          t5 = <MarkupError>{t4}</MarkupError>;
          $[9] = t4;
          $[10] = t5;
        } else {
          t5 = $[10];
        }
        t3 = t5;
        break bb0;
      }
      iframeURL = new URL(posixPath.join("https://www.youtube.com/embed", youtubeId));
      iframeURL.searchParams.set("enablejsapi", "1");
      iframeURL.searchParams.set("disablekb", "1");
      iframeURL.searchParams.set("rel", "0");
      iframeURL.searchParams.set("origin", origin);
    }
    $[3] = origin;
    $[4] = src;
    $[5] = iframeURL;
    $[6] = t3;
  } else {
    iframeURL = $[5];
    t3 = $[6];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  const t4 = iframeURL.href;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = translateInline({
      en: "YouTube video",
      nl: "YouTube video"
    });
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== className || $[13] !== iframeURL.href || $[14] !== t5) {
    t6 = <iframe ref={iFrameRef} src={t4} title={t5} allowFullScreen={true} allow="autoplay" className={className} />;
    $[12] = className;
    $[13] = iframeURL.href;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};